module.exports = new __parcel__URL__("luigis-mansion-3.1f6949d8.jpg").toString();